import VueRouter from 'vue-router'

import Login from '@/components/Auth/Login'
import Register from '@/components/Auth/Register'
import ChangeCard from '@/components/Auth/ChangeCard'

import RegisterSuccess from '@/components/Auth/RegisterSuccess'
import SchimbareCardSuccess from '@/components/Auth/SchimbareCardSuccess'


import RegisterSuccessOp from '@/components/Auth/RegisterSuccessOp'
import ForgotPassword from '@/components/Auth/ForgotPassword'
import ForgotPasswordSuccess from '@/components/Auth/ForgotPasswordSuccess'
import ResetPassword from '@/components/Auth/ResetPassword'
import ResetPasswordSuccess from '@/components/Auth/ResetPasswordSuccess'

import Objectives from '@/components/Pages/Objectives'
import MasterGoals from '@/components/Pages/MasterGoals'
import ShowObjective from '@/components/Pages/ShowObjective'
import ShowMasterGoal from '@/components/Pages/ShowMasterGoal'

import Maintenance from '@/components/Auth/Maintenance'

import Users from '@/components/Pages/Users'
import ShowUser from '@/components/Pages/ShowUser'
import Reports from '@/components/Pages/Reports'

import Game from '@/components/Pages/Game'

import PublicMasterGoal from '@/components/Pages/PublicMasterGoal'

import NotFound from '@/components/Pages/NotFound'

const routes = [
	// Main Pages
	{ path: '/change-card', name: 'change_card', component: ChangeCard, meta: { auth: false, layout: 'change-card-template' }},
	{ path: '*', name: 'register', component: Register, meta: {layout: 'login-template' }},
	{ path: '/register-success', name: 'register-success', component: RegisterSuccess, meta: { auth: true, layout: 'login-template' }},
	// { path: '*', redirect: { name: 'maintenance' }},
	// { path: '/login', name: 'login', component: Login, meta: { auth: false, layout: 'login-template' }},
	  {
	      path: '/login',
	      beforeEnter(to, from, next) {
	          window.location.replace("https://tbf.ro/oferta")
	      }
	  },
	{ path: '/schimbare-card-cu-success', name: 'schimbare-card-cu-success', component: SchimbareCardSuccess, meta: { auth: false, layout: 'login-template' }},

	{ path: '/register', name: 'register', component: Register, meta: { auth: false, layout: 'login-template' }},
	{ path: '/register-success', name: 'register-success', component: RegisterSuccess, meta: { auth: true, layout: 'login-template' }},
	{ path: '/register-success-op', name: 'register-success-op', component: RegisterSuccessOp, meta: { auth: true, layout: 'login-template' }},
	// { path: '/password/forgot', name: 'password-forgot', component: ForgotPassword, meta: { auth: false, layout: 'login-template' }},
	// { path: '/password/forgot-success', name: 'password-forgot-success', component: ForgotPasswordSuccess, meta: { auth: false, layout: 'login-template' }},
	// { path: '/reset-password/:token', name: 'password-reset', component: ResetPassword, meta: { auth: false, layout: 'login-template' }},
	// { path: '/reset-success', name: 'password-reset-success', component: ResetPasswordSuccess, meta: { auth: false, layout: 'login-template' }},
	{ path: '/payment', name: 'payment', component: Register, meta: { auth: true, layout: 'login-template' }},
	
	// { path: '/', name: 'homepage', component: ShowUser, meta: { auth: true, layout: 'main-template' }},
	// { path: '/dashboard', name: 'dashboard', component: ShowUser, meta: { auth: true, layout: 'main-template' }},

	// { path: '/obiective', name: 'objectives', component: Objectives, meta: { auth: true, layout: 'main-template' }},
	// { path: '/obiectiv/:slug', name: 'show-objective', component: ShowObjective, meta: { auth: true, layout: 'main-template' }},

	// //Modals Page
	// { path: '/obiectiv/:slug/:krId/:modalType', name: 'show-objective-modal', component: ShowObjective, meta: { auth: true, layout: 'main-template' }},

	// { path: '/master-goals', name: 'master-goals', component: MasterGoals, meta: { auth: true, layout: 'main-template' }},
	// { path: '/master-goal/:slug', name: 'show-master-goal', component: ShowMasterGoal, meta: { auth: true, layout: 'full-page' }},

	// { path: '/oameni', name: 'users', component: Users, meta: { auth: true, layout: 'main-template' }},
	// { path: '/utilizator/:slug', name: 'show-user', component: ShowUser, meta: { auth: true, layout: 'main-template' }},
	// { path: '/rapoarte', name: 'reports', component: Reports, meta: { auth: true, layout: 'main-template' }},
	
	// { path: '/public/:uuid', name: 'public-master-goal', component: PublicMasterGoal, meta: { auth: undefined, layout: 'full-page' }},

	  // {
	  //     path: '*',
	  //     beforeEnter(to, from, next) {
	  //         window.location.replace("https://tbf.ro/oferta")
	  //     }
	  // },
	// { path: '/game', name: 'game', component: Game, meta: { auth: true, layout: 'full-page' }},
	// { path: '/404', name: 'page-404', component: NotFound, meta: { auth: true, layout: 'main-template' }},
	// { path: '*', name: 'not-exist', component: NotFound, meta: { auth: true, layout: 'main-template' }},
]

const router = new VueRouter({
	history: true,
	mode: 'history',
	routes,
	linkActiveClass: 'active'
})

export default router
